export default __webpack_public_path__ + "static/media/Vertical_AHU_2_unselected.607c7b85.svg";